import { InfoIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import { Auth } from 'aws-amplify';
import { useFormik } from 'formik';
import React, { useRef, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { inputTextStyleProps } from '../../utils/stylesProps';

const ChangePasswordView = ({ onChangePasswordClose, isOpen }) => {
  const [passwordSecure, setPasswordSecure] = useState(false);
  const [oldPasswordSecure, setOldPasswordSecure] = useState(false);
  const [confirmPasswordSecure, setConfirmPasswordSecure] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const toast = useToast();
  const cancelRef = useRef();

  const changePassword = async ({ oldPassword, newPassword }) => {
    try {
      setChangePasswordLoading(true);
      const userObj = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(userObj, oldPassword, newPassword);
      setChangePasswordLoading(false);
      onChangePasswordClose();
      toast({
        title: 'Success',
        description: 'Successfully Changed Password',
        position: 'top',
      });
    } catch (error) {
      setChangePasswordLoading(false);
      toast({
        title: 'Error',
        description: error?.message || 'Something went wrong. Please try again',
        position: 'top',
      });
    }
  };

  const changePasswordFormik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    onSubmit: (values) => {
      changePassword({
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });
    },
  });

  const { values, handleBlur, handleSubmit, handleChange } =
    changePasswordFormik;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onChangePasswordClose();
        changePasswordFormik.resetForm();

        setOldPasswordSecure(false);
        setConfirmPasswordSecure(false);
        setChangePasswordLoading(false);
      }}
      size="3xl"
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <form onSubmit={handleSubmit}>
        <ModalContent minH="40%">
          <ModalHeader color="brand.white" fontSize="16px" bg="brand.red">
            Change Password
          </ModalHeader>
          <ModalCloseButton color="brand.white" />
          <ModalBody>
            <Box>
              <FormControl id="oldPassword" isRequired>
                <FormLabel> Old password</FormLabel>
                <InputGroup>
                  <Input
                    {...inputTextStyleProps}
                    type={!oldPasswordSecure ? 'password' : 'text'}
                    onBlur={handleBlur}
                    value={values.oldPassword}
                    name="oldPassword"
                    onChange={handleChange}
                    placeholder="Please enter old password"
                  />
                  <InputRightElement>
                    <Button
                      tabIndex="-1"
                      color="brand.black"
                      variant="link"
                      onClick={() => {
                        setOldPasswordSecure(!oldPasswordSecure);
                      }}
                    >
                      {oldPasswordSecure ? <FaEye /> : <FaEyeSlash />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <FormControl id="newPassword" isRequired>
                <HStack>
                  <FormLabel> New password</FormLabel>
                  <Tooltip
                    hasArrow
                    label="Password should be contain Min Length 6, One Numerical, One Caps, One Special Chatacter."
                    bg="brand.red"
                  >
                    <InfoIcon fontSize="12px" color="brand.red" />
                  </Tooltip>
                </HStack><InputGroup>
                  <Input
                    {...inputTextStyleProps}
                    type={!passwordSecure ? 'password' : 'text'}
                    onBlur={handleBlur}
                    value={values.newPassword}
                    name="newPassword"
                    onChange={handleChange}
                    placeholder="Please enter password"
                  />
                  <InputRightElement>
                    <Button
                      tabIndex="-1"
                      color="brand.black"
                      variant="link"
                      onClick={() => {
                        setPasswordSecure(!passwordSecure);
                      }}
                    >
                      {passwordSecure ? <FaEye /> : <FaEyeSlash />}
                    </Button>
                  </InputRightElement>
                </InputGroup>

              </FormControl>
              <FormControl
                id="newPassword"
                isInvalid={
                  values.confirmPassword?.length > 0 &&
                  values.newPassword !== values.confirmPassword
                }
                isRequired
              >
                <FormLabel>Confirm Password</FormLabel>
                <InputGroup>
                  <Input
                    {...inputTextStyleProps}
                    type={!confirmPasswordSecure ? 'password' : 'text'}
                    onBlur={handleBlur}
                    value={values.confirmPassword}
                    name="confirmPassword"
                    onChange={handleChange}
                    placeholder="Please Re-enter password"
                  />
                  <InputRightElement>
                    <Button
                      tabIndex="-1"
                      color="brand.black"
                      variant="link"
                      onClick={() => {
                        setConfirmPasswordSecure(!confirmPasswordSecure);
                      }}
                    >
                      {confirmPasswordSecure ? <FaEye /> : <FaEyeSlash />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                <FormErrorMessage>
                  {' '}
                  Password and confirm password do not match{' '}
                </FormErrorMessage>
              </FormControl>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onChangePasswordClose();
                changePasswordFormik.resetForm();

                setOldPasswordSecure(false);
                setConfirmPasswordSecure(false);
                setChangePasswordLoading(false);
              }}
              variant="cancel-button"
            >
              Cancel
            </Button>
            <Button
              ml="2"
              isLoading={changePasswordLoading}
              type="submit"
              _hover={{ background: 'brand.red' }}
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};
export default ChangePasswordView;
